<template>
  <section class="index-initial flex flex-wrap w-full h-screen bg-cover bg-center bg-no-repeat relative">
    <div class="w-full mx-auto index-initial__ctn relative z-10">
        <img class="text-center w-full mb-32 mx-auto max-w-md block" src="@/assets/images/logo.svg">
        <p>
          <router-link to="/" class="text-center text-white mb-8 block pt-2">Exit Debug Area</router-link>
        </p>  
        <ul class="list-reset w-full text-center flex items-stretch flex-no-wrap px-20">
          <li class="index-initial__nav-btn mr-4 inline-block bg-white rounded no-underline uppercase text-4xl flex items-center flex-1">
            <a href="#" @click.prevent="start" class="inline-block w-full no-underline text-grey-darkest hover:text-red-dark sans-bd w-full px-2 py-12">Start Animation</a>
          </li>
        </ul>
    </div>
  </section>
</template>
<script>

export default {
  name: 'AnimationPage',

  data () {
    return {
      cue: 2010
    }
  },

  methods: {
    start () {
      this.$store.dispatch('osc/sendOscTriggerForced', this.cue)

      this.$router.push('/')
    }
  }
}
</script>
